import * as React from "react";

export const ConstLink = ({ value }) => (
	<div>{value ? <a href={value?.link_url}> {value?.link_title}</a> : <div />}</div>
);
